import {Parameter, Pdf417Barcode} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class PortalPdf417Barcode extends Pdf417Barcode implements Parameter {
	public dimensions?: boolean;

	constructor(data: any) {
		super(data);

		this.dimensions = FunctionHelper.exists(data?.dimensions) ? data.dimensions : false;
	}

	public static getDimensionsDefault(): boolean {
		return false;
	}

	public static fromJson(data: any): PortalPdf417Barcode {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalPdf417Barcode(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'dimensions': this.dimensions
		};
	}

	public clone(): PortalPdf417Barcode {
		return PortalPdf417Barcode.fromJson(this.toJson());
	}
}